import React, {Component} from 'react';
import PropTypes from 'prop-types';

import Tab from './Tab';

class Tabs extends Component {
  constructor(props) {
    super(props);

    this.state = {
      activeTab: this.props.children[0].props.label,
    };
  }

  onClickTabItem = (tab) => {
    const {onTabChange} = this.props.onTabChange;

    this.setState({activeTab: tab}, onTabChange);
  };

  render() {
    const {
      onClickTabItem,
      props: {
        children,
        className,
      },
      state: {
        activeTab,
      }
    } = this;

    return (
      <div className="rct-tabs">
        <div className="tabs row">
          <ul className={className}>
            {children.map((child, index) => {

              if(!child) {
                return null;
              }

              const {label = ''} = child.props;

              return (
                <Tab
                  activeTab={activeTab}
                  key={label + index}
                  label={label}
                  onClick={onClickTabItem}
                />
              );
            })}
          </ul>
          <div className="tab-content sm-12">
            {children.map((child) => {

              if(!child) {
                return null;
              }

              return child.props.label === activeTab && child.props.children;
            })}
          </div>
        </div>
      </div>
    );
  }
}

Tabs.propTypes = {
  children: PropTypes.instanceOf(Array).isRequired,
  onTabChange: PropTypes.func,
  className: PropTypes.string,
};

Tabs.defaultProps = {
  onTabChange: () => {},
  className: 'sm-12 d-flex util-space-between tab-list',
};

export default Tabs;




// WEBPACK FOOTER //
// ./js/components/global/tabs/Tabs.js